import { createSlice } from '@reduxjs/toolkit';

export const user = createSlice({
  name: 'user',
  initialState: {
    isAuth: false,
    orgId: null,
    token: {
      access: '',
      refresh: '',
    },
    userInfo: {},
    selectedTemplateId: 0,
    selectedEmailTemplateId: 0,
    selectedTimeRange: null,
    selectedBackground: '#181818',
    selectedHover: {
      selectedBg: '#E8F4FE',
      selectedColor: '#1677FF',
    },
    selectedBrandLogo: '',
    selectedInsight: 'Calls',
  },
  reducers: {
    setuserInfo: (state, action) => {
      state.userInfo = action.payload;
    },
    setAuth: (state, action) => {
      state.isAuth = action.payload;
    },
    setOrgId: (state, action) => {
      state.orgId = action.payload;
    },
    setToken: (state, action) => {
      state.token = action.payload;
    },
    setSelectedTemplateId: (state, action) => {
      state.selectedTemplateId = action.payload;
    },
    setSelectedEmailTemplateId: (state, action) => {
      state.selectedEmailTemplateId = action.payload;
    },
    setSelectedTimeRange: (state, action) => {
      state.selectedTimeRange = action.payload;
    },
    setSelectedBackground: (state, action) => {
      state.selectedBackground = action.payload;
    },
    setSelectedHover: (state, action) => {
      state.selectedHover = action.payload;
    },
    setSelectedBrandLogo: (state, action) => {
      state.selectedBrandLogo = action.payload;
    },
    setSelectedInsight: (state, action) => {
      state.selectedInsight = action.payload;
    },
    resetUser: (state) => {
      state.isAuth = false;
      state.token = {
        access: '',
        refresh: '',
      };
      state.userInfo = {};
      state.selectedTemplateId = 0;
      state.selectedEmailTemplateId = 0;
      state.selectedTimeRange = null;
      state.selectedBackground = '#181818';
      state.selectedHover = {
        selectedBg: '#E8F4FE',
        selectedColor: '#1677FF',
      };
      state.selectedBrandLogo = '';
      state.selectedInsight = 'Calls';
    },
  },
});

export const {
  setAuth,
  setToken,
  setuserInfo,
  resetUser,
  setSelectedTemplateId,
  setSelectedEmailTemplateId,
  setSelectedTimeRange,
  setOrgId,
  setSelectedBackground,
  setSelectedHover,
  setSelectedBrandLogo,
  setSelectedInsight,
} = user.actions;

export default user.reducer;
